import {
  Component,
  Host,
  h,
  Element,
  Prop,
  Watch,
} from "@stencil/core";

import { StzhEditorLink } from "../../../index";

import { StzhEditorLocalizedText } from "./stzh-editor.localization";

/**
 *
 */
@Component({
  tag: "stzh-editor",
  styleUrl: "stzh-editor.scss",
  scoped: true
})
export class StzhEditor {
  /** Translation strings */
  @Prop() localization: StzhEditorLocalizedText;

  /** Heading text (overwrite default one) */
  @Prop() heading: string;

  /** 
   * Items. Array of objects that can include the attributes `href`, `label`, `rel`, `target` and `icon`
   * `[{"href":"#", "label": "Lorem"}, {"href":"#", "label": "Lorem"}]
   */
  @Prop() items: string | StzhEditorLink[];
  private _items: StzhEditorLink[];

  @Element() element: HTMLStzhEditorElement;

  @Watch("items")
  itemsWatcher(newValue: string | StzhEditorLink[]) {
    if (typeof newValue === "string") {
      this._items = JSON.parse(newValue);
    } else {
      this._items = newValue;
    }
  }

  async componentWillLoad() {
    this.itemsWatcher(this.items);

    if (!this.localization) {
      this.localization = await window.stzhComponents.utils.fetchTranslations(this.element, "editor");
    }
  }

  render() {
    const classes = {
      "stzh-editor": true
    };

    return (
      <Host>
        <div class={classes}>
          <div class="stzh-editor__wrapper">
            <h2 class="stzh-editor__heading">
              {typeof this.heading === "string" ? this.heading : this.localization.heading}
            </h2>
            <ul class="stzh-editor__link-list">
              {this._items.map((link) =>
                <li class="stzh-editor__link-item">
                  <stzh-link
                    class="stzh-editor__link"
                    {...link}
                    icon={typeof link.icon === "undefined" ? "arrow-right" : link.icon}
                    iconPosition={"right"}
                  ></stzh-link>
                </li>
              )}
            </ul>
          </div>
        </div>
      </Host>
    );
  }
}
